import { useState } from 'react';
import { Store } from 'lucide-react';
import { getCommercantLogoUrl } from '../utils/commercantListUtils';

/**
 * Avatar boutique : logo réel ou initiale.
 */
export default function CommercantListAvatar({ commercant, sizeClass = 'h-10 w-10' }) {
  const logoUrl = getCommercantLogoUrl(commercant);
  const [imgFailed, setImgFailed] = useState(false);

  if (logoUrl && !imgFailed) {
    return (
      <img
        src={logoUrl}
        alt={commercant?.nom ? `Logo ${commercant.nom}` : 'Logo boutique'}
        className={`${sizeClass} rounded-full object-cover border border-gray-200 flex-shrink-0`}
        onError={() => setImgFailed(true)}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 border border-primary-200`}
    >
      {commercant?.nom ? (
        <span className="text-sm font-semibold text-primary-700">
          {commercant.nom.charAt(0).toUpperCase()}
        </span>
      ) : (
        <Store className="h-5 w-5 text-primary-600" />
      )}
    </div>
  );
}
